<template>
	<div class="wrapper" @click="togleVisible">
		<div v-for="(word, i) of words" :key="i" class="word">
			<div class="word-number hint">{{ i + 1 }}</div>
			<div>{{ word }}</div>
		</div>
	</div>
</template>

<script setup lang="tsx">
import { computed, ref } from 'vue';

const props = defineProps<{
	phrase: string;
}>();

const visible = ref(false);

const togleVisible = () => {
	visible.value = !visible.value;
};

const words = computed(() => {
	const array = props.phrase.split(' ');
	return visible.value ? array : array.map((e) => e.replace(/./g, '*'));
});
</script>

<style scoped>
.wrapper {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
	gap: var(--size-xs);
	user-select: none;
	cursor: pointer;
}

.word {
	display: flex;
	flex-direction: row;
	align-items: center;
	padding: 8px 10px;
	gap: 6px;

	background: #0d1325;
	border-radius: 8px;
}

.word-number {
	user-select: none;
}
</style>
